import { useTrackExternalCalendarConnected as _useTrackExternalCalendarConnected } from '@griply/hooks';
import { useMemo } from 'react';
import { useExternalCalendarConnectionsQuery } from 'shared/hooks/queries/use-external-calendar-connections-query';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import { useUser } from 'shared/hooks/use-user';
import {
  externalCalendarConnectedIdsKeyPrefix,
  getExternalCalendarConnectedIds,
  setExternalCalendarConnectedIds,
} from 'shared/services/local-storage';

export const useTrackExternalCalendarConnected = () => {
  const user = useUser();
  const { data } = useExternalCalendarConnectionsQuery(user?.uid);
  const track = useTrackEvents();

  const storage = useMemo(
    () => ({
      read: getExternalCalendarConnectedIds,
      write: setExternalCalendarConnectedIds,
    }),
    [],
  );

  _useTrackExternalCalendarConnected({
    uid: user?.uid,
    connections: data,
    keyPrefix: externalCalendarConnectedIdsKeyPrefix,
    storage,
    track,
  });
};
